import FAQs from 'features/shared/FAQs';

export default function ChallengeFAQs() {
  return (
    <FAQs className="container-sm" heading="Challenge FAQs">
      <FAQs.FAQ question="How can I get help if I'm stuck on a challenge?" />
      <FAQs.FAQ question="How do I submit my solution?" />
      <FAQs.FAQ question="Is there an official solution I can take a look at?" />
      <FAQs.FAQ question="Do I get a code review when I post my solution?" />
      <FAQs.FAQ question="Can I use libraries/frameworks on these projects?" />
      <FAQs.FAQ question="Can I use these projects in my portfolio?" />
      <FAQs.FAQ question="How often are new challenges added?" />
      <FAQs.FAQ question="What is the difference between the desktop-design, mobile-design, and desktop-preview images in my starter code?" />
      <FAQs.FAQ question="Can I use these challenges within my own free or commercial content/tutorials/projects?" />
    </FAQs>
  );
}
